<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Kunde löschen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text>
          Sie möchten den Kunden <b>{{customer.name}} ({{customer.email}})</b> wirklich löschen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="deleteCustomer"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DeleteCustomerConfirmDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      customer: {
        type: Object,
        default: function () {
          return {
            id: 0,
            email: '',
            name: ''
          }
        }
      }
    },
    methods: {
      deleteCustomer () {
        this.$store.dispatch('removeCustomer', this.customer.id)
          .then(() => this.$store.dispatch('showNotification', {
            title: 'Kunde erfolgreich gelöscht.',
            type: 'primary'
          }))
          .finally(() => this.$emit('close'))
      }
    }
  }
</script>

<style scoped>
  .v-subheader {
    margin-left: -32px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Customers/DeleteCustomerConfirmDialog.vue